/**
 * Blank ink while auth is still resolving or a hop is in flight.
 * Never the keypad — a signed-in person must not see it flash.
 */
export function InkHold() {
  return (
    <div
      className="fixed inset-0 z-[9999] min-h-dvh bg-ink"
      aria-busy="true"
      aria-live="polite"
    />
  );
}
